export const useScrollToTop = () => {
	const handleScrollToTop = (top = 0) => {
		return window.scrollTo(0, top);
	};

	return { handleScrollToTop };
};
